"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

var _installTask = require("@/api/cms/installTask");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OperationRecord',
  props: {
    installTaskId: {
      type: [Number, String],
      default: null
    },
    contractNumber: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  watch: {
    installTaskId: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.currentPage = 1;
          this.loadData();
        }
      }
    },
    contractNumber: {
      immediate: true,
      handler: function handler(val) {
        if (val) {
          this.currentPage = 1;
          this.loadData();
        }
      }
    }
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      if (!this.installTaskId && !this.contractNumber) return;
      this.loading = true;
      var params = {
        page: this.currentPage - 1,
        size: this.pageSize
      };

      if (this.installTaskId) {
        params.installTaskId = this.installTaskId;
      }

      if (this.contractNumber) {
        params.contractNumber = this.contractNumber;
      }

      (0, _installTask.getInstallTaskLog)(params).then(function (response) {
        if (response.code === 200) {
          _this.recordList = response.data.content || [];
          _this.total = response.data.totalElements || 0;
        } else {
          _this.$message.error(response.msg || '加载操作记录失败');
        }
      }).catch(function () {
        _this.$message.error('网络错误');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handlePageChange: function handlePageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    isSignIn: function isSignIn(step) {
      return step && step.includes('签到');
    },
    isBeforeInstall: function isBeforeInstall(step) {
      return step && step.includes('待服务');
    },
    isInProgress: function isInProgress(step) {
      return step && step.includes('待完工');
    },
    isComplete: function isComplete(step) {
      return step && step.includes('待完成');
    },
    getPhotoList: function getPhotoList(photo) {
      if (!photo) return [];
      return photo.split(',').map(function (url) {
        return url.trim();
      }).filter(function (url) {
        return url;
      });
    },
    getTimelineColor: function getTimelineColor(step) {
      if (!step) return '#909399';
      if (step.includes('预约')) return '#E6A23C';
      if (step.includes('签到')) return '#409EFF';
      if (step.includes('待服务')) return '#67C23A';
      if (step.includes('待完工')) return '#409EFF';
      if (step.includes('待完成')) return '#67C23A';
      return '#909399';
    }
  }
};
exports.default = _default;